import { cx } from '@emotion/css';
import React from 'react';
import Scrollbars from 'components/scroll/Scrollbars';
import './layout.css';

export type CenteredPageProps = {
  className?: string;
};

export const CenteredPage = ({ children, className }: React.PropsWithChildren<CenteredPageProps>) => (
  <Scrollbars>
    <div className="wrap">
      <div className="overlay">
        <div className={cx('conciseWindow', className)}>{children}</div>
      </div>
    </div>
  </Scrollbars>
);

export default CenteredPage;
